import { cx } from "class-variance-authority";

import { Svg } from "../../../utils/svgIcon";

import sidebarLockSvg from "./sidebar-lock.svg";
import * as theme from "./SidebarLockBadge.css";

export interface SidebarLockBadgeProps {
    className?: string;
}

export function SidebarLockBadge({ className }: SidebarLockBadgeProps) {
    return (
        <span className={cx(theme.root, className)} aria-hidden>
            <Svg src={sidebarLockSvg} className={theme.glyph} />
        </span>
    );
}
